/* eslint-disable @typescript-eslint/no-unused-vars */
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SessionService } from '@/common/auth/auth-session.service';

@Injectable({
  providedIn: 'root'
})
export class RoleGuard implements CanActivate {
  constructor(
    private sessionService: SessionService,
    private router: Router
  ) {
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    // The route's own data: a child inherits its parent's data when its path is '' or its parent has no component, and a
    // guarded child must not take its parent's roles (the settings area lets admins in; its roles pages don't). `role`:
    // one role; `roles`: any one of them.
    const data = route.routeConfig?.data ?? route.data;
    const guardedRoles: string[] = (data['roles'] as string[] | undefined) ?? [data['role'] as string];

    return this.sessionService.userSessionState$.pipe(
      map(userSession => {
        if (guardedRoles.some(role => this.sessionService.hasRole(role))) {
          return true;
        }

        // `refused`: where a refused user goes instead (an admin sent to the roles pages stays in settings)
        this.router.navigate([(data['refused'] as string | undefined) ?? '/projects']);
        return false;
      })
    );
  }
}
